const routers = [
  {
    path: '/settings',
    name: 'settingsDashboard',
    meta: { title: 'settings.settingsTitle', roles: ['ADMIN'] },
    component: () => import('@/pages/settings/Dashboard'),
  },
]
export default routers
